<template>
  <tr v-if="!isMobile">
    <td v-if="status == 'new'">
      <checkbox-block v-model="mail.active" @input.native="$emit('remove-selection')">
      </checkbox-block>
    </td>
    <td class="number">
      {{ mail.mail_number }}
      <a v-if="mail.comments" href="#" class="icon" @click.prevent="$emit('comment', mail)">
        <include-svg :name="'icon-mail-comment'" />
      </a>
    </td>
    <td class="sender">
      <text-truncate :text="mail.sender" />
    </td>
    <td class="date">{{ mail.received_at.split('T')[0] | moment('MMM D, YYYY') }}</td>
    <td class="type sm-txt-capitalize">{{ mail.type }}</td>
    <td class="qty sm-txt-center">{{ mail.quantity }}</td>
    <td class="date">{{ mail.requested_date | moment('MMM D, YYYY') }}</td>
    <td class="status">
      <status-progress :mail="mail"></status-progress>
      <span
        v-for="(status, index) in parsedMailStatuses"
        :key="status.value"
        :class="status.class"
      >{{status.value}}{{shouldInsertComma(index, status) ? ', ' : ''}}</span>
      <hint-wrap
        v-if="mail.tracking_code"
        :text="'View tracking code'"
        :delay="0"
      >
        <template slot="content">
          <a href="#" class="sm-link" @click.prevent="openTrackingCode(mail)">
            <include-svg :name="'icon-tracking'" />
          </a>
        </template>
      </hint-wrap>


    </td>
    <td>
      <div v-if="!mail.actionStatus.active" class="sm-list__table-actions">
        <div
          v-for="action in mail.actionStatus.actions"
          :key="action.name"
          class="sm-list__table-action"
          @mouseenter.prevent="actionEnter(action)"
          @mouseleave="actionLeave(action)"
        >
          <a
            v-if="!action.processed && !action.restriction || (action.name === 'picture' && !mail.picture_requested_at && !action.restriction)"
            href="#"
            class="icon"
            :class="{'disabled': !isPickable && action.name === 'pick_up'}"
            @click.prevent="$emit('action', {
              item: mail,
              action: action.name,
              enabled: true
            })">
            <include-svg :name="action.btn.icon" />
            <hint-block v-if="action.showHint">
              <template slot="hintContent">{{ action.btn.text }}</template>
            </hint-block>
          </a>

          <a
            v-else-if="action.result && mail[action.result.field] && (action.name != 'scan' || !action.restriction)"
            :href="isApproved ? mail[action.result.field] : '#'"
            @click="openLink($event,mail,action)"
            target="_blank"
            class="result"
            :class="{
              'picture': action.name == 'picture'
            }">
            <scan-preview v-if="action.name == 'scan'" :src="mail[action.result.field]" :showHint="action.showHint" />
            <img-preview v-if="action.name == 'picture'" :src="mail[action.result.field]" :showHint="action.showHint" />
          </a>

          <a v-else href="#" class="icon disabled">
            <include-svg :name="action.btn.icon" />
            <hint-block v-if="action.showHint && (action.processed || action.restriction)">
              <template slot="hintContent">{{ action.processed || action.restriction }}</template>
            </hint-block>
          </a>
        </div>
      </div>
      <div v-else class="sm-list__table-actions">
        <template  v-if="mail.actionStatus.actions">
          <div
            v-for="action, index in mail.actionStatus.actions" :key="index"
            class="sm-list__table-action single"
            @mouseenter="actionEnter(action)"
            @mouseleave="actionLeave(action)"
          >
            <a
              href="#"
              class="icon"
              :class="{'disabled': !isPickable && action.name === 'pick_up'}"
              @click.prevent="$emit('action', {
                item: mail,
                action: action.name,
                enabled: action.enabled,
                trashNow: action.trash_now,
              })"
            >
              <include-svg :name="action.btn.icon" />
              <hint-block v-if="action.showHint">
                <template slot="hintContent">{{ action.hint }}</template>
              </hint-block>
            </a>
          </div>
        </template>
        <template v-else>
          <div class="sm-list__table-action single" @mouseenter="actionEnter(mail.actionStatus.action)"
            @mouseleave="actionLeave(mail.actionStatus.action)">
            <a v-if="mail.actionStatus.action.link" href="#" class="link" @click.prevent="$emit('action', {
              item: mail,
              action: mail.actionStatus.action.name,
              enabled: false
            })">
              {{ mail.actionStatus.action.link.text }}
              <hint-block v-if="mail.actionStatus.action.showHint" class="cancel">
                <template slot="hintContent">{{ mail.actionStatus.action.hint }}</template>
              </hint-block>
            </a>
          </div>
        </template>
      </div>

      <div class="sm-list__table-actions-mobile" @click="showPopup(mail)">
        <a href="#"></a>
      </div>
      <div class="sm-list__table-actions-popup" v-if="mail.popupOpen" v-click-outside="hidePopup">
        <ul v-if="!mail.actionStatus.active">
          <li
            v-for="(action, index) in mail.actionStatus.actions"
            :key="action.name"
            :class="{'delimiter': index == 2, 'hidden': processedAction && (!action.result || !mail[action.result.field])}"
          >
            <a
              v-if="!action.processed && !action.restriction"
              href="#"
              :class="{'disabled': !isPickable && action.name === 'pick_up'}"
              @click.prevent="$emit('action', {
                item: mail,
                action: action.name,
                enabled: true
              })"
            >{{action.btn.text}}</a>
            <a
              v-else-if="action.result && mail[action.result.field]"
              :href="isApproved ? mail[action.result.field] : '#'"
              @click="openLink($event,mail,action)"
              class="result"
              target="_blank"
            >{{action.result.text}}</a>

            <span v-else>{{ action.processed || action.restriction || action.btn.text }}</span>
          </li>
        </ul>
        <div v-else class>
          <template  v-if="mail.actionStatus.actions">
            <a
              v-for="action, index in mail.actionStatus.actions" :key="index"
              href="#"
              class="icon"
              :class="{'disabled': !isPickable && action.name === 'pick_up'}"
              @click.prevent="$emit('action', {
                item: mail,
                action: action.name,
                enabled: action.enabled,
                trashNow: action.trash_now
              })"
            >{{action.btn.text}}</a>
          </template>
          <template v-else>
            <a v-if="mail.actionStatus.action.link" href="#" class="link" @click.prevent="$emit('action', {
              item: mail,
              action: mail.actionStatus.action.name,
              enabled: false
            })">{{ mail.actionStatus.action.hint }}</a>
          </template>
        </div>
        <div v-if="processedAction" class="sm-list__table-actions-popup-hint sm-small">Item is
          {{ processedAction.processed }}, can't process any more actions</div>
      </div>
    </td>
  </tr>
  <div v-else class="sm-mobile-table-item" :class="mail.itemOpen ? 'open' : ''">
    <div class="sm-mobile-table-item-row">
      <div class="sm-mobile-table-item-row-elem sender" @click="toggleItem(mail)">
        <include-svg :name="'icon-arrow-b-bold'" />
        <text-truncate :text="mail.sender" />
        <a v-if="mail.comments" href="#" class="icon" @click.prevent="$emit('comment', mail)">
          <include-svg :name="'icon-mail-comment'" />
        </a>
      </div>
      <div class="sm-mobile-table-item-row-elem date">{{ mail.received_at.split('T')[0] | moment('MMM D') }}</div>
      <div class="sm-mobile-table-item-row-elem actions" @click="showPopup(mail)">
        <a href="#"></a>
      </div>
    </div>
    <ul class="sm-mobile-table-item-dropdown">
      <li>
        <span>№</span>
        <span>{{ mail.mail_number }}</span>
      </li>
      <li>
        <span>Type</span>
        <span class="sm-txt-capitalize">{{ mail.type }}</span>
      </li>
      <li>
        <span>Qty.</span>
        <span>{{ mail.quantity }}</span>
      </li>
      <li>
        <span>Request Date</span>
        <span>{{ mail.requested_date | moment('MMM D, YYYY') }}</span>
      </li>
      <li>
        <span>Status</span>
        <span>
         <status-progress :mail="mail"></status-progress>
         <span
            v-for="(status, index) in parsedMailStatuses"
            :key="status.value"
            :class="status.class"
          >{{status.value}}{{shouldInsertComma(index, status) ? ', ' : ''}}</span> 
        </span>
      </li>
      <li v-if="mail.status == 'pending' && mail.actionStatus.action.link">
        <a v-if="mail.actionStatus.action.link" href="#" class="link sm-link-blue" @click.prevent="$emit('action', {
          item: mail,
          action: mail.actionStatus.action.name,
          enabled: false
        })">
          {{ mail.actionStatus.action.link.text }}
        </a>
      </li>
    </ul>
    <div
      class="sm-mobile-table-item-popup"
      v-if="mail.popupOpen"
      v-click-outside="hidePopup"
    >
      <ul
        v-if="!mail.actionStatus.active"
      >
        <li
          v-for="(action, index) in mail.actionStatus.actions"
          :key="action.name"
          :class="{'delimiter': index == 2, 'hidden': processedAction && (!action.result || !mail[action.result.field])}"
        >
          <a
            v-if="(!action.processed && !action.restriction) || (action.name === 'picture' && !mail.picture_requested_at && !action.restriction)"
            href="#"
            :class="{'disabled': !isPickable && action.name === 'pick_up'}"
            @click.prevent="$emit('action', {
              item: mail,
              action: action.name,
              enabled: true
            })">
            {{ action.btn.text }}
          </a>
          <a
              v-else-if="action.result && mail[action.result.field]"
              :href="isApproved ? mail[action.result.field] : '#'"
              @click="openLink($event, mail, action)"
              class="result"
              target="_blank"
            >{{action.result.text}}</a>
          <span v-else>{{action.processed || action.restriction || action.btn.text}}</span>
        </li>
      </ul>
      <div
        v-else
        class=""
      >
       <template  v-if="mail.actionStatus.actions">
        <a
          v-for="action, index in mail.actionStatus.actions" :key="index"
          href="#"
          class="icon"
          :class="{'disabled': !isPickable && action.name === 'pick_up'}"
          @click.prevent="$emit('action', {
            item: mail,
            action: action.name,
            enabled: action.enabled,
            trashNow: action.trash_now
          })">
            {{ action.btn.text }}
          </a>
        </template>
        <template v-else>
          <a v-if="mail.actionStatus.action.link" href="#" class="link" @click.prevent="$emit('action', {
            item: mail,
            action: mail.actionStatus.action.name,
            enabled: false
          })">
            {{ mail.actionStatus.action.hint }}
          </a>
        </template>
      </div>
      <div v-if="processedAction" class="sm-mobile-table-item-popup-hint sm-small">Item is {{ processedAction.processed }},
        can't process any more actions</div>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/Checkboxes.vue';
import Hint from '@/components/Hint.vue';
import { mapActions, mapGetters } from 'vuex';
import vClickOutside from 'v-click-outside';
import ImgPreview from '@/components/ImgPreview';
import ScanPreview from '@/components/mail/ScanPreview';
import MailParams from '@/settings/mail';
import ViewPort from '@/mixins/ViewPort';
import StatusProgress from '@/components/mail/StatusProgress';
import HintWrap from '@/components/HintWrap';
import parseStatuses from '@/utils/parseMailStatuses';
export default {
  name: "item-mail",
  components: {
    'checkbox-block': Checkbox,
    'hint-block': Hint,
    'hint-wrap': HintWrap,
    'img-preview': ImgPreview,
    'scan-preview': ScanPreview,
    'status-progress': StatusProgress
  },
  props: {
    mail: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    isApproved: {
      type: Boolean,
      required: true
    },
    isPickable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      timer: null,
      curMail: {},
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],
      mailRequests: {
        urgent: [
          'Same Day Scan requested',
          'Two Days Scan requested',
          'Expedited forward requested'
        ],
        regular: [
          'Shred requested',
          'Scan requested',
          'Forward requested',
          'Expedited forward requested',
          'Envelope picture requested',
          'Pick up requested',
          'Mark as pick up requested',
          'Mark as junk',
          'Marked as pick up requested by the user',
          'Check deposit requested',
          'Stored'
        ]
      },
      terminalMailActions: ['Picked up', 'Mail forwarded', 'Shredded'],
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    }),
    processedAction() {
      let res;

      if (!this.mail.actionStatus.active)
        res = this.mail.actionStatus.actions.find(action => action.processed && MailParams.nonRevertableActions.includes(action.name));

      return res;
    },
    parsedMailStatuses(){
      return parseStatuses(this.mail);
    },
  },
  mixins: [ViewPort],
  methods: {
    shouldInsertComma(index, status) {
      return index < this.parsedMailStatuses.length - 1 && !status.class;
    },
    openLink(event,mail,action) {
      if (!this.isApproved) {
        event.preventDefault();
        this.$emit('action', {
          item: mail,
          action: action.name,
          enabled: action.enabled,
        });
      }
    },
    statusClass() {

    },
    showPopup(mailItem) {
      setTimeout(() => mailItem.popupOpen = true, 0);
    },
    hidePopup(mailItem) {
      this.$emit('hide');
    },
    toggleItem(mailItem) {
      mailItem.itemOpen = !mailItem.itemOpen;
    },
    actionEnter(action) {
      this.timer = setTimeout(() => {
        action.showHint = true;
      }, 500);
    },
    actionLeave(action) {
      action.showHint = false;
      clearTimeout(this.timer);
    },
    openTrackingCode(mail) {
      this.$router.push(`/customer/tracking?item=${mail.mail_number}&mail_id=${mail.id}`);
    },
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
};
</script>
